export default __webpack_public_path__ + "static/media/gm-png-girl.def6daad.webp";